export const colors = {
  primary: { value: '#5c6ac4' },
  secondary: { value: '#006fbb' },
  fog: {
    DEFAULT: { value: '#99a1af' },
    50: { value: '#f8f9fa' },
    100: { value: '#f1f3f4' },
    200: { value: '#e4e6ea' },
    300: { value: '#dde0e4' },
    400: { value: '#bbc1ca' },
    500: { value: '#99a1af' },
    600: { value: '#778295' },
    700: { value: '#596273' },
    800: { value: '#3b4351' },
    900: { value: '#1e2330' },
  },
  mint: {
    DEFAULT: { value: '#32c0a0' },
    50: { value: '#f5fcfa' },
    100: { value: '#ebf9f6' },
    200: { value: '#ccefe7' },
    300: { value: '#98dfcf' },
    400: { value: '#65d0b8' },
    500: { value: '#32c0a0' },
    600: { value: '#25917b' },
    700: { value: '#196257' },
    800: { value: '#0c3332' },
    900: { value: '#05171d' },
  },
  lightning: {
    DEFAULT: { value: '#3366FF' },
    50: { value: '#f5f7ff' },
    100: { value: '#ebf0ff' },
    200: { value: '#ccd9ff' },
    300: { value: '#99b2ff' },
    400: { value: '#668cff' },
    500: { value: '#3366FF' },
    600: { value: '#264dc3' },
    700: { value: '#193586' },
    800: { value: '#0d1c4a' },
    900: { value: '#001238' },
  },
  dusk: {
    DEFAULT: { value: '#f3565d' },
    50: { value: '#fef7f7' },
    100: { value: '#feeeef' },
    200: { value: '#fcd5d7' },
    300: { value: '#f9abae' },
    400: { value: '#f68086' },
    500: { value: '#f3565d' },
    600: { value: '#b64149' },
    700: { value: '#792d35' },
    800: { value: '#3d1822' },
    900: { value: '#180c16' },
  },
  solar: {
    DEFAULT: { value: '#fbc02d' },
    50: { value: '#fffcf4' },
    100: { value: '#fff9ea' },
    200: { value: '#feefcb' },
    300: { value: '#fddf96' },
    400: { value: '#fcd062' },
    500: { value: '#fbc02d' },
    600: { value: '#bc9125' },
    700: { value: '#7d621d' },
    800: { value: '#3f3316' },
    900: { value: '#191711' },
  },
};
